import VehicleDamageExport from './VehicleDamageExport';

export default VehicleDamageExport;